import ReactVisibilitySensor from "react-visibility-sensor"
import Separator from "../../../components/Separator"
import BorderLeftBox from "../../../components/boxes/BorderLeftBox"
import SecondaryCard from "../../../components/cards/SecondaryCard"
import socialPageData from "../../../data/arabic/subpages/social-page-data-ar"
import Footer from "../../../layouts/Footer"
import MainHeader from "../../../layouts/MainHeader"
import TabsView from "../../../components/tabs/TabsView/TabsView"
import tabsViewOneData from "../../../data/arabic/tabs/tabsViewOneDataAr"
import TitleSection from "../../../components/sections/TitleSection"

const SocialPageAr = () => {

    return (
        <main className="page" id="main">
          <div id="stickyViewTwo" className="sticky-view-two type-two">
            <div className="sticky-container">
              <MainHeader
                image={{
                  src: require("../../../assets/images/headers/social.jpg"),
                  alt: "Social Impacts",
                }}
                title=""
              />
            </div>
            <div className="sticky-container-two" id="mainContent">
              <div className="background-wrapper">
                <div className="wrapper-small">
                  {/* <div className="space-25"></div> */}
                  <h1 className="title-center">{socialPageData.mainHeader}</h1>
                  <div className="space-50"></div>
                  <BorderLeftBox
                    title={socialPageData.borderSection.title}
                    subtitle={socialPageData.borderSection.subtitle}
                  />
                  <p
                    className={`text-paragraph`}
                  >
                    {socialPageData.paragraphOne}
                  </p>
                  <p
                    className={`text-paragraph`}
                  >
                    {socialPageData.paragraphTwo}
                  </p>
                  <p
                    className={`text-paragraph`}
                  >
                    {socialPageData.paragraphThree}
                  </p>
                </div>
                <div className="space-50"></div>
                <div className="space-50"></div>
                {/* <Separator /> */}
                <TitleSection title={socialPageData.sectionOne.title} />
                {socialPageData.sectionOne.cards.map((item, index) => (
                  <SecondaryCard
                    key={index}
                    title={item.title}
                    subtitle={item.subtitle}
                    icon={{
                      name: require(`../../../assets/icons/social/${item.icon}`),
                      alt: "",
                    }}
                  />
                ))}
                <div className="space-50"></div>
                <div className="space-50"></div>
                <div className="wrapper-larg" style={{ position: "sticky" }}>
                  <TabsView
                    titles={socialPageData.tabsView.titles}
                    data={tabsViewOneData}
                  />
                </div>
                <div className="space-50"></div>
                <div className="space-50"></div>
                <div className="space-50"></div>
                <Footer withBlogs={false} />
              </div>
            </div>
          </div>
        </main>
      );
}

export default SocialPageAr